import React from 'react';
import { Table } from '@material-ui/core';
import { getShiftEmploye, hasTransfer, genTooltipTitleLabel, calculShiftDuration } from '../../../utilities/shiftFunctions';
import CustomToolTip from '../../../components/UI/ToolTip/ToolTip';
import Collapse from '../../../components/UI/Collapse/Collapse';
import { exists } from '../../../../common/utilities/utilitiesFunctions';
import _ from 'lodash';
import { detailedDiff } from "deep-object-diff";
import moment from 'moment';
import { UkgDateFormat } from '../../../../WorkplanManager/Enums';
import DateFormatService from '../../../../WorkplanManager/services/DateFormatService';

export const genBodyTooltipPaycode = (paycode) => {
    if (exists(paycode.payCodeEditTemplate)) {
        let nbHours = paycode.payCodeEditTemplate.durationInTime ? Math.floor(paycode.payCodeEditTemplate.durationInTime / 3600) : 0;
        let nbMinutes = paycode.payCodeEditTemplate.durationInTime ? paycode.payCodeEditTemplate.durationInTime % 3600 : 0;

        return (<span>
            {paycode.payCodeEditTemplate.payCode.qualifier + '  [' + nbHours + ':' + (nbMinutes === 0 ? '00' : nbMinutes) + ']'}
        </span>)
    } else {
        if (typeof paycode.durationInTime !== 'undefined') {
            let duration = 0;
            if (typeof (paycode.durationInTime) === 'string') {
                let splitValue = paycode.durationInTime.split(':');
                duration = (parseInt(splitValue[0], 10) + parseInt(splitValue[1], 10) / 60).toFixed(2);
            } else {
                duration = (paycode.durationInTime / 60).toFixed(2);
            }

            return (<span>
                {paycode.name + ' ' + moment(paycode.startTime).format('H:mm') + '  [' + duration + 'h]'}
            </span>)
        } else {
            return (<span>
                {paycode.label}
            </span>)
        }
    }
}

const genTooltipTitle = (shift) => {
    return (
        <React.Fragment>
            <div style={{ fontWeight: 'bold' }}>{genTooltipTitleLabel(shift)}</div>
            <div style={{ fontWeight: 'bold' }}>
                {DateFormatService.formatDateOrEmpty(shift.startDateTime, UkgDateFormat.TimeFormat)} - {DateFormatService.formatDateOrEmpty(shift.endDateTime, UkgDateFormat.TimeFormat)}
            </div>
        </React.Fragment>
    );
};


const translateSegmentType = (segmentType, t) => {
    const key = segmentType.toLowerCase();
    const translationKey = `ShiftDetails.segmentTypes.${key}`;
    const translation = t(translationKey);
    // If translation key not found, fallback to formatted segment type
    return translation !== translationKey ? translation : _.startCase(_.toLower(segmentType));
};

const genToolTipShiftSegments = (segments, t, isTemplate = true) => {
    return (
        typeof segments === 'undefined' ? '' : segments.map((segment, index) => {
            let transferString = [];
            let segmentType = segment.segmentType.qualifier.split('_')[0];

            if (segment.segmentType.qualifier !== 'BREAK_SEGMENT') {
                if (segment.orgNode !== null) {
                    transferString.push(segment.orgNode.qualifier);
                }
                if (segment.costCenter !== null) {
                    transferString.push(segment.costCenter.costCenter.qualifier);
                    segmentType = 'Transfer';
                }
                if (segment.workRule !== null) {
                    transferString.push(segment.workRule.qualifier);
                    segmentType = 'Transfer';
                }
                if (segment.userEnteredLaborCategories !== null && (segment.userEnteredLaborCategories || segment.transferLaborCategories)) {
                    transferString.push(segment.userEnteredLaborCategories.laborString);
                    segmentType = 'Transfer';
                }
            }
            const shiftDuration = calculShiftDuration(segment);
            const shiftDurationHour = `${shiftDuration.toString().split('.')[0]}`;
            const minutesMulitplier = `0.${shiftDuration.toString().split('.')[1]}`;
            const shiftDurationMinutes = Math.round(Number(minutesMulitplier) * 60);
            const shiftDurationMinutesFormatted = shiftDurationMinutes < 10 ? `0${shiftDurationMinutes}` : shiftDurationMinutes.toString();
            const shiftDurationFormatted =`${shiftDurationHour}:${shiftDurationMinutesFormatted}`;

            return (
                <React.Fragment key={`shift-segments-${segment.id}-${segment.orderNumber}-${index}`}>
                    {index === 0 && !isTemplate ? <tr><td colSpan={4}>{t('ShiftDetails.shiftStartDate') + segment.startDateTime.substring(0, 10)}</td></tr> : ''}
                    <Table>
                        <tbody>
                            <tr>
                                <td style={{ paddingRight: '10px', width: '20px' }}>{index + 1}.</td>
                                <td style={{ paddingRight: '10px', width: '80px' }}>{DateFormatService.formatDateOrEmpty(segment.startDateTime, UkgDateFormat.TimeFormat)}</td>
                                <td style={{ paddingRight: '10px', width: '40px' }}>{'[' + _.toLower(shiftDurationFormatted) + ']:'}</td>
                                <td style={{ fontWeight: 'bold' }}>{translateSegmentType(segmentType, t)}</td>
                            </tr>
                            {
                                transferString.map((transfer, transferIndex) => {
                                    return transfer !== '' ?
                                        <React.Fragment key={`shift-segment-transfer-${transfer}-${transferIndex}-${index}`}>
                                            <tr>
                                                <td colSpan={2} style={{ paddingRight: '10px' }} />
                                                <td colSpan={2}>{transfer}</td>
                                            </tr>
                                        </React.Fragment>
                                        : ''
                                })
                            }
                            {
                                segment.segmentSCProfiles !== null ?
                                    <React.Fragment key={`shift-segments-skill-certif-${segment.id}-${segment.orderNumber}-${index}`}>
                                        <tr>
                                            <td colSpan={2} style={{ paddingRight: '10px' }}></td>
                                            <td colSpan={2}>{t('ShiftDetails.skillAndCertificationProfiles')}</td>
                                        </tr>
                                        {segment.segmentSCProfiles.map((x, scpIndex) => {
                                            return <React.Fragment key={`shift-segment-skill-certif-profile-${x.qualifier}-${scpIndex}-${index}`}>
                                                <tr>
                                                    <td colSpan={2} style={{ paddingRight: '10px' }}></td>
                                                    <td colSpan={2}>{x.qualifier}</td>
                                                </tr>
                                            </React.Fragment>
                                        })
                                        }
                                    </React.Fragment>

                                    : ''
                            }
                        </tbody>
                    </Table>
                </React.Fragment>
            )
        })
    )
}

const genToolTipShiftComments = (commentNotes) => {
    return (
        typeof commentNotes === 'undefined' ? '' : commentNotes.map((comment, index) => {
            return (
                <React.Fragment>
                    {index === 0 ? <tr style={{ height: '15px' }}></tr> : ''}
                    <tr><td colSpan={4} style={{ fontWeight: 'bold' }}>{comment.comment.name}</td></tr>
                    {typeof comment.notes === 'undefined' ? '' : comment.notes.map((note) => <tr><td colSpan={4} >{note.text}</td></tr>)}
                </React.Fragment>
            )
        })
    )
}

export const genBodyTooltipShiftTemplate = (shift, t, isTemplate) => {
    return (
        <React.Fragment>
            {genTooltipTitle(shift)}
            {genBodyTooltipShiftTemplateBody(shift.segments, shift.commentNotes, t, isTemplate)}
        </React.Fragment>
    )
}

export const genBodyTooltipShiftTemplateBody = (segments, commentNotes, t, isTemplate) => {
    return (
        <div style={{ paddingTop: '20px', width: '100%' }}>
            <div spacing={1}>
                <div style={{ width: '100%', fontSize: '0.85rem !important', borderBottom: '1px solid #3a3a3a', marginBottom: 5 }}>
                    {t('ShiftDetails.segments')}
                </div>
                {genToolTipShiftSegments(segments, t, isTemplate)}
                {genToolTipShiftComments(commentNotes)}
            </div>
        </div>
    )
}

export const checkVersionHasModifications = (v1, v2) => {
    let compare = detailedDiff(v1, v2);

    if (!Object.keys(compare.added).length === 0 || !Object.keys(compare.deleted).length === 0) {
        return true;
    }

    for (const key in compare.updated) {
        switch (key) {
            case 'revisionId':
            case 'auditUser':
            case 'auditTimestamp':
            case 'value':
            case 'auditLocalTimestamp':
            case 'index':
                break;
            case 'shift':
                for (const key2 in compare.updated.shift) {
                    switch (key2) {
                        case 'version':
                            break;
                        default:
                            return true;
                    }
                }
                break;
            default:
                return true;
        }
    }
    return false;
}

export const genBodyTooltipShiftVersion = (version, previousVersion = {}, index, dataviewData, genToolTipEmployee, actions, handleClickShiftId, t, isTemplate) => {
    const shift = version.shift;

    let eeId = getShiftEmploye(shift);
    let eeDataview = _.find(dataviewData, ['eeId', eeId]);
    let shiftId = typeof previousVersion !== 'undefined' ? ((version.shiftId !== previousVersion.shiftId || index === 1) ? ' : ' + version.shiftId : '') : index === 1 ? ' : ' + version.shiftId : '';
    let divVersion = <div style={{ width: '100%', fontWeight: 'bold', border: '1px solid lightgray', padding: '3px 10px', borderRadius: '5px 5px 0px 0px' }}>{'Version ' + index + shiftId}</div>;

    let divUpdate = <div style={{ width: '100%', border: '1px solid lightgray', padding: '3px 10px' }}>
        <div style={{ width: '100%' }}>{t('ShiftDetails.updateBy') + _.startCase(version.auditUser)}</div>
        <div style={{ width: '100%' }}>{t('ShiftDetails.updateOn') + version.auditLocalTimestamp.replace('T', ' ')}</div>
    </div>

    let divEmployee = <div style={{ width: '100%', border: '1px solid lightgray', padding: '4px 10px 4px 4px', display: 'flex', height: '40px' }}>
        <div style={{ minWidth: '90px', paddingTop: '3px' }}>{eeId !== 'Unassigned' ? t('ShiftDetails.assignTo') : t('ShiftDetails.unassigned')}</div>
        <div>{eeId !== 'Unassigned' ? genToolTipEmployee(eeDataview, true) : ''}</div>
    </div>

    let actionsSchedule = [];
    let actionsCallList = [];

    let segmentSchedule = _.filter(actions, ['source', 'schedule']);
    segmentSchedule = _.orderBy(segmentSchedule, ['segmentIndex', 'asc']);
    let segmentCallList = _.filter(actions, ['source', 'calllist']);

    for (const action of segmentSchedule) {
        if (typeof action.segmentIndex === 'undefined') {
            if (typeof action.shiftSwappedId === 'undefined') {
                actionsSchedule.push(<div style={{ width: '100%', paddingLeft: '30px' }}>{action.action}</div>);
            } else {
                let swapEmployeeDataview = _.find(dataviewData, ['eeId', action.shiftSwappedEmployee.id]);
                let transfert = hasTransfer(shift) ? ' (x)' : '';

                let shiftLabel = typeof action.shiftSwapped !== 'undefined' ?
                    <CustomToolTip
                        style={{ width: '100%' }}
                        placement={'top'}
                        enterDelay={1000}
                        leaveDelay={0}
                        titletext={genBodyTooltipShiftTemplate(action.shiftSwapped, t)}
                        jsx={
                            <div style={{ width: '30%' }}>
                                {/* onClick={() => handleClickShiftId(action.shiftSwappedId)} > */}
                                <span >{(typeof action.shiftSwapped.label !== 'undefined' && action.shiftSwapped.label !== '') ? action.shiftSwapped.label + transfert : action.shiftSwapped.startDateTime.substring(11, 16) + ' - ' + action.shiftSwapped.endDateTime.substring(11, 16) + transfert}</span>
                            </div >
                        }
                    />
                    : action.shiftSwappedId

                actionsSchedule.push(
                    <div>
                        <div style={{ width: '100%', paddingLeft: '30px' }}>{action.action}</div>
                        <div style={{ paddingLeft: '60px', display: 'flex' }}>
                            <div style={{ paddingTop: '3px' }}>{action.typeSwap}</div>
                            <div style={{ paddingLeft: '5px', paddingTop: '3px' }}>{shiftLabel}</div>
                        </div>
                        <div style={{ paddingLeft: '60px' }}>{action.labelTypeSwapEE}{typeof swapEmployeeDataview !== 'undefined' ? genToolTipEmployee(swapEmployeeDataview, false) : action.shiftSwappedEmployee.qualifier}</div>
                    </div>
                );
            }
        }
    }

    let curSegmentIndex = 0;
    for (const action of segmentSchedule) {
        if (typeof action.segmentIndex !== 'undefined') {
            if (curSegmentIndex !== action.segmentIndex) {
                actionsSchedule.push(<div style={{ width: '100%', paddingLeft: '30px' }}>{'Segment ' + action.segmentIndex + ' :'}</div>)
            }
            actionsSchedule.push(<div style={{ width: '100%', paddingLeft: '60px' }}>{action.action}</div>);
        }
        curSegmentIndex = action.segmentIndex;
    }

    let divActionsSchedule = actionsSchedule.length > 0 ?
        <div style={{ width: '100%', border: '1px solid lightgray', padding: '4px 10px 4px 4px', minHeight: '43px', display: 'flex', flexWrap: 'wrap' }}>
            <div style={{ width: '100%' }}>{t('ShiftDetails.editDetails')}</div>
            {actionsSchedule}
            {/* {actions.map(action => <Chip style={{ margin: '0.5px' }} label={t('ShiftDetails.' + action.action)} variant="outlined" />)} */}
        </div>
        : '';

    for (const action of segmentCallList) {
        let note = typeof action.notes !== 'undefined' ? '  : ' + action.notes + ' ' : '';
        let eeNameTime = typeof action.eeName !== 'undefined' ? '  ( ' + action.eeName + ' - ' + action.time + ' )' : '';

        actionsCallList.push(<div style={{ width: '100%', paddingLeft: '30px' }}>
            {
                action.action
                + note
                + eeNameTime
            }
        </div>);
    }

    let divActionsCallList = actionsCallList.length > 0 ?
        <div style={{ width: '100%', border: '1px solid lightgray', padding: '4px 10px 4px 4px', minHeight: '43px', display: 'flex', flexWrap: 'wrap' }}>
            <Collapse title={t('ShiftDetails.callList')}>
                {actionsCallList}
            </Collapse>
        </div>
        : '';

    let divShiftDetails = <div style={{ width: '100%', border: '1px solid lightgray', padding: '3px 10px', borderRadius: '0px 0px 5px 5px' }}>
        {genTooltipTitle(shift)}
        <div style={{ paddingTop: '20px' }}>
            <Table container spacing={1}>
                {genToolTipShiftSegments(shift.segments, t, isTemplate)}
                {genToolTipShiftComments(shift.commentNotes)}
            </Table>
        </div>
    </div>

    return (
        <React.Fragment>
            {divVersion}
            {divUpdate}
            {divEmployee}
            {divActionsSchedule}
            {divActionsCallList}
            {divShiftDetails}
        </React.Fragment>
    )
}

export const genBodyTooltipShiftWfc = (shift) => {
    return (
        <React.Fragment>
            {genTooltipTitleWfc(shift)}
            <div style={{ paddingTop: '20px' }}>
                <Table container spacing={1}>
                    {genToolTipShiftSegmentsWfc(shift.shiftSegments)}
                    {genToolTipShiftCommentsWfc(shift.comments)}
                </Table>
            </div>
        </React.Fragment>
    )
}

const genToolTipShiftSegmentsWfc = (segments) => {
    return (
        typeof segments === 'undefined' ? '' : segments.map((segment, index) => {
            return (
                <React.Fragment>
                    <tr>
                        <td style={{ paddingRight: '10px' }}>{index + 1}.</td>
                        <td style={{ paddingRight: '10px' }}>{segment.StartDate}</td>
                        <td style={{ paddingRight: '10px' }}>{'[' + _.toLower(calculSegmentDurationWfc(segment)) + 'h]:'}</td>
                        <td>{_.startCase(_.toLower(segment.SegmentTypeName))}</td>
                    </tr>
                    {_.toLower(segment.SegmentTypeName).indexOf('transfer') !== -1 ?
                        <tr>
                            <td colSpan={3} style={{ paddingRight: '10px' }} />
                            <td>{segment.OrgJobPath}</td>
                        </tr>
                        : ''}
                </React.Fragment>
            )
        })
    )
}

const genToolTipShiftCommentsWfc = (commentNotes) => {
    return (
        typeof commentNotes === 'undefined' ? '' : commentNotes.map((comment, index) => {
            return (
                <React.Fragment>
                    {index === 0 ? <tr style={{ height: '15px' }}></tr> : ''}
                    <tr><td colSpan={4} style={{ fontWeight: 'bold' }}>{comment.CommentText}</td></tr>
                    {typeof comment.notes === 'undefined' ? '' : comment.notes.map((note) => { return <tr><td></td><td colSpan={3} >{note.Text}</td></tr> })}
                </React.Fragment>
            )
        })
    )
}

const calculSegmentDurationWfc = (segment) => {
    return moment.duration(
        moment(segment.EndDate + ' ' + segment.EndTime, 'M/DD/YYYY h:mmA')
            .diff(
                moment(segment.StartDate + ' ' + segment.StartTime, 'M/DD/YYYY h:mmA')
            )
    ).as('hours');
}

export const calculShiftDurationWfc = (shift) => {
    let duration = 0;

    for (const segment of shift.shiftSegments) {
        duration += segment.SegmentTypeName === "BREAK" ? 0 : calculSegmentDurationWfc(segment);
    }

    return duration;
}

const genTooltipTitleWfc = (shift) => {
    return <span>
        {shift.shiftSegments[0].StartTime
            + ' - ' + shift.shiftSegments[shift.shiftSegments.length - 1].EndTime
            + '  (' + calculShiftDurationWfc(shift) + ')'}
    </span>
}